const NAMESPACE = "addProjectNote";

const KEYS = {
    noteContentInputLabel: "noteContentInputLabel",
    cancelBtnLabel: "cancelBtnLabel",
    saveBtnLabel: "saveBtnLabel",
    emptyContentValidationMessage: "emptyContentValidationMessage",
    oversizeContentValidationMessage: "oversizeContentValidationMessage",
    remainingCharMsg: "remainingCharMsg"
};

const MESSAGES = {
    [KEYS.noteContentInputLabel]: {
        value: "Add Note",
        comment: "Label for the textarea where the new note content is specified"
    },
    [KEYS.cancelBtnLabel]: { value: "Cancel", comment: "Label for the button that cancels adding new note" },
    [KEYS.saveBtnLabel]: { value: "Save", comment: "Label for the button that saves new note with specified content" },
    [KEYS.emptyContentValidationMessage]: {
        value: "Blank notes cannot be saved.",
        comment: "Validation error message that indicates that an empty note cannot be saved"
    },
    [KEYS.oversizeContentValidationMessage]: {
        value: "Notes must be {maxNoteLength} characters or less.",
        comment: "Validation error message that indicates that the note content exceeds the maximum allowed length"
    },
    [KEYS.remainingCharMsg]: {
        value: "Remaining Characters: {charactersRemaining}",
        comment: "Message for alerting user how many allowed characters are left."
    }
};

export { KEYS, NAMESPACE, MESSAGES };
